<template>
  <v-card class="elevation-12">
    <v-toolbar
      color="info"
      dark
      flat
    >
      <v-toolbar-title>Login</v-toolbar-title>
    </v-toolbar>

    <form @submit.prevent="authenticate">
      <v-card-text>
        <v-text-field
          v-model="login.email"
          label="Login"
          prepend-icon="mdi-account"
          type="email"
          :error-messages="loginFormErrors.getMessage('email')"
        />
        <v-text-field
          id="password"
          v-model="login.password"
          label="Password"
          prepend-icon="mdi-lock"
          type="password"
          :error-messages="loginFormErrors.getMessage('password')"
        />
      </v-card-text>
      <v-card-text class="pt-0 pb-0">
        <p>
          Forget Password ?
          <router-link to="/forget-password">
            Reset here
          </router-link>
        </p>
      </v-card-text>
      <v-card-actions>
        <v-btn href="/welcome">
          Home
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          type="submit"
        >
          Login
        </v-btn>
      </v-card-actions>
    </form>
  </v-card>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      login: {
        email: "",
        password: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      authenticated: "auth/authenticated",
      loginFormErrors: "validation/pull",
    }),
  },

  methods: {
    ...mapActions({
      boot: "configs/initialize",
      feedback: "snackbar/show",
    }),

    authenticate() {
      window.axios.post("/login", this.$data.login).then(() => {
        this.boot().then(() => {
          if (this.authenticated) {
            this.feedback("Logged in successfully !");
            this.$router.replace({ name: "Dashboard" });
          }
        });
      });
    },
  },
};
</script>
